import { Swiper, SwiperSlide } from "swiper/react";

import { PARTNERS } from '../../../../Utilities/APIs'
import useFetch from '../../../../Utilities/Hooks/useFetch'
import Image from '../../../Partials/Elements/Image/Image';

import "swiper/css";
import './Partner.css'
import { useSelector } from "react-redux";

function Partner() {
    const [data, loading] = useFetch(PARTNERS, 'true')

    const {consumer} = useSelector(state => state.auth)

    return (
        <section className="our_partner spb">
            <div className="container">
                <div className="sh_wrapper">
                    <h3 className='sc_heading'>
                        {
                            consumer
                            ?
                                consumer.language === 'english'
                                ?
                                    'Our Partners'
                                :
                                    'আমাদের পার্টনার'
                            :
                                'আমাদের পার্টনার'
                        }
                    </h3>
                </div>
                <div className="partner_carousel">
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={30}
                        breakpoints={{
                            640: {
                                slidesPerView: 5,
                              }
                        }}
                        className="mySwiper"
                    >
                        {data?.map((data) => (
                            <SwiperSlide key={data._id}>
                                <div className="icons">
                                    <div className="partner_icon">
                                        <Image imgSrc={data.image} imgAlt='partner' />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                        {loading ? '...loading' : ''}
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default Partner